import { Injectable, OnDestroy } from '@angular/core';
import { ReplaySubject } from 'rxjs';
import { PlantingSiteDto } from '../../../models/trofaco/plantingSiteDto';

@Injectable()
export class SiteListAccessService implements OnDestroy {

    constructor() {
    }

    updateFilteredSites(sites: PlantingSiteDto[]) {
        this._filteredSites$.next([...sites]);
    }

    private _filteredSites$ = new ReplaySubject<PlantingSiteDto[]>(1);

    get filteredSites$() {
        return this._filteredSites$.asObservable();
    }

    ngOnDestroy(): void {
        this._filteredSites$.complete();
        this._filteredSites$.unsubscribe();
    }
}
